import { Typography } from "@mui/material";
import React, { forwardRef } from "react";
import Text, { TextProps } from "./Text";
import { TooltipProps } from "../tooltip/Tooltip";

interface OverflowCombinedTextProps {
	/** main text */
	mainText: string;

	/** properties for main text section */
	mainTextProps?: Partial<TextProps>;

	/** secondary text */
	secondaryText: string;

	/** properties for secondary text section */
	secondaryTextProps?: Partial<TextProps>;

	/** separator between the main and secondary text */
	separator: string;

	/** properties for separator section */
	separatorProps?: Partial<TextProps>;

	/** properties for tooltip */
	tooltipProps?: Partial<TooltipProps>;
}

const OverflowCombinedText = forwardRef<HTMLDivElement, OverflowCombinedTextProps>((props, ref) => {
	const { mainText, secondaryText, separator, mainTextProps, secondaryTextProps, separatorProps } = props;

	return (
		<Typography noWrap ref={ref}>
			<Text text={mainText} {...mainTextProps} />
			{secondaryText &&
				<Text text={separator} {...separatorProps} />
			}
			{/* make the display "initial" so that the group name won't truncate until it needs to  */}
			<Text
				style={{ display: "initial" }}
				text={secondaryText}
				{...secondaryTextProps}
			/>
		</Typography>
	);
});

export default OverflowCombinedText;